export default "__VITE_ASSET__lhQb8iiWCMKClPlyeXwOgw__"